import { Button, Header, Message, Segment, Icon } from "@/components/bp/bp-ui";
import { Frown } from 'lucide-react';

const BPUnauthorized: React.FC = () => {
    return (
        <Segment placeholder>
            <Header icon>
                <Icon><Frown size={50} /></Icon>
                Unauthorized
            </Header>
            <div style={{textAlign: "center"}}>
                <p>Sorry, you do not have permission to view this page.</p>
            </div>
        </Segment>
    );
};

export default BPUnauthorized;